import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://static.readdy.ai/image/3e6f353e8dbbec4f9360c3b978f4989c/15d1fbc80a4e83bc9e25c6a466182daa.png"
          alt="ADF Biomédical - Dispositifs médicaux"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-20">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-4 md:mb-6 leading-tight">
            Votre partenaire en dispositifs médicaux
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl text-white/90 mb-8 md:mb-12 max-w-3xl mx-auto px-4">
            Distribution de dispositifs médicaux de haute qualité pour les établissements de santé en Algérie
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center px-4">
            <Link
              to="/products"
              className="w-full sm:w-auto px-8 sm:px-10 py-3 sm:py-4 bg-[#E31B23] text-white rounded-lg font-medium text-base sm:text-lg hover:bg-[#C41820] transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              Découvrir nos produits
            </Link>
            <Link
              to="/contact"
              className="w-full sm:w-auto px-8 sm:px-10 py-3 sm:py-4 bg-white text-[#1A1A1A] rounded-lg font-medium text-base sm:text-lg hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              Nous contacter
            </Link>
          </div>
        </motion.div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          <i className="ri-arrow-down-line text-4xl text-white/80"></i>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
